module.exports = __webpack_public_path__ + "img/device_am35_m_a.fb74283e.png";